import { type StopEditingEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function stopEditingReducer(
  state: SelectionState,
  event: StopEditingEvent
): ReducerResponse {
  if (!state.activeEdit) {
    return { next: state, delta: { kind: 'noop' } };
  }

  const position =
    state.activeEdit.editingContext === 'panel'
      ? state.activeEdit.position
      : (state.focusedCell ?? state.activeEdit.position);
  const next = {
    ...state,
    activeEdit: null
  };

  return {
    next,
    delta: {
      kind: 'cellEditStopped',
      position,
      source: event.source
    }
  };
}
